export default "__VITE_ASSET__8ea48d40__"